import { combineReducers } from 'redux';

import basicState, { basicInitialState } from './basic';
import descModalState, { descModalInitial } from './descModal';
import executeModalState, { executeModalInitial } from './executeModal';

export const pipelinesInitialState = { 
  basicState: basicInitialState,
  descModalState: descModalInitial,
  executeModalState: executeModalInitial,
}

export default combineReducers({
  basicState,
  descModalState,
  executeModalState
})